import React, { Component } from "react";
import { connect } from "react-redux";

import { TabNavigation, Carousel, PrevStepButton, NextStepButton, Logo } from "components";
import CustomerItem from "./customer-item";
import { MOVE_TAB } from "actions";

class Tab5B extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.activeTab === "tab5a" && nextProps.activeTab === "tab5b") {
      return true;
    }
    return false;
  }
  render() {
    const props = this.props;
    return (
      <div className="form_steps">
        <div className="form_steps--inner ">
          <div className="full_column">
            <Logo />
            <TabNavigation />
            <div className="three_blocks">
              <div className="width-1-3">
                <div className="inner_block">
                  <h2 className="three_blocks--title">{props.domain.Strings.tab5BTitle}</h2>
                  <PrevStepButton onClick={props.moveToPreviousTab} text={props.domain.Strings.tab5BPrevBtn} />
                  <NextStepButton hideForMedium text={props.domain.Strings.tab5BNextBtn} onClick={props.moveToNextTab} />
                </div>
              </div>
              <div className="width-2-3">
                {this.props.customers.length > 0 && (
                  <Carousel
                    textPrev={props.domain.Strings.tab5BCarouselPrev}
                    textNext={props.domain.Strings.tab5BCarouselNext}
                    children={this.props.customers.map((customer, i) => {
                      return <CustomerItem key={i} i={i} />;
                    })}
                  />
                )}
              </div>
              <NextStepButton showForMedium text={props.domain.Strings.tab5BNextBtn} onClick={props.moveToNextTab} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    moveToPreviousTab: () => dispatch({ type: MOVE_TAB, dir: "back", from: ownProps.tab }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab5B);
